import React, { Fragment } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import PieChart from '../chart/PieChart';
import BarChart from '../chart/BarChart';
import { pieChartColors, clientOptionsKeyFieldsMapping } from './createStatistics';
import type { ClientStatistic as ClientStatisticType } from '../../common/types/statistics/dndStatistics';

type Props = {
  clientStatistics: ClientStatisticType;
};

function ClientStatistic({ clientStatistics }: Props) {
  return (
    <Stack direction='column' spacing={2}>
      {clientOptionsKeyFieldsMapping.map(({ key, fields }) => {
        const statisticByKey = clientStatistics[key];
        const field = fields.find((field) => field.key === key);

        if (field == null || (field.fieldTypes !== 'select' && field.fieldTypes !== 'checkboxSelect')) {
          return null;
        }
        const chart = field.chart;

        const chartOptions =
          chart != null && chart.options != null
            ? chart.options.map((entry) => {
                const value = entry.keys.reduce((prevValue, key) => prevValue + statisticByKey[key], 0);
                return { name: entry.label, value };
              })
            : field.options
                .map((option) => {
                  return { name: option.label, value: statisticByKey[option.value] };
                })
                .concat([{ name: 'k. A.', value: statisticByKey.notSpecified }]);

        const chartData = chartOptions.filter((option) => option.value != null);

        return (
          <Fragment key={key}>
            {field.label != null && (
              <Typography fontSize='1.2rem' fontWeight='bold'>
                {chart != null ? chart.heading : field.label}
              </Typography>
            )}
            <Stack key={key} direction='row' spacing={2} justifyContent='space-between'>
              {chart != null && chart.type === 'pie' && <PieChart data={chartData} colors={pieChartColors} />}
              {chart != null && chart.type === 'bar' && <BarChart data={chartData} />}
              <Stack direction='column' minWidth='250px'>
                {Object.keys(statisticByKey).map((statisticKey) => {
                  const option = field.options.find((option) => option.value === statisticKey);
                  return option == null ? null : (
                    <Typography key={statisticKey}>
                      {option.label}: {statisticByKey[statisticKey]}
                    </Typography>
                  );
                })}
                <Typography>k. A.: {statisticByKey.notSpecified}</Typography>
              </Stack>
            </Stack>
          </Fragment>
        );
      })}
    </Stack>
  );
}

export default ClientStatistic;
